"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandFromEngineBrand = brandFromEngineBrand;
exports.brandFromProto = brandFromProto;
exports.brandToProto = brandToProto;
exports.brandToEngineBrand = brandToEngineBrand;
exports.stringToBrand = stringToBrand;
exports.stringToEngineBrand = stringToEngineBrand;
exports.engineBrandFromProto = engineBrandFromProto;
exports.brandToLanguage = brandToLanguage;
exports.brandToAnalytics = brandToAnalytics;
exports.protoBrandToAnalytics = protoBrandToAnalytics;
exports.brandAndEnvToAdminUrl = brandAndEnvToAdminUrl;
exports.brandAndEnvToAppUrl = brandAndEnvToAppUrl;
exports.dayOfWeekToProto = dayOfWeekToProto;
exports.dayOfWeekFromProto = dayOfWeekFromProto;
exports.problemTypeToProto = problemTypeToProto;
exports.problemTypeFromProto = problemTypeFromProto;
exports.stringToProblemType = stringToProblemType;
exports.getPaginationControls = getPaginationControls;
exports.limitOffsetFromPageRequest = limitOffsetFromPageRequest;
exports.nextPageTokenFromLimitOffset = nextPageTokenFromLimitOffset;
const zod_1 = __importDefault(require("zod"));
const globals_1 = require("@eucalyptusvc/protobufs/globals");
function brandFromEngineBrand(engineBrand) {
    switch (engineBrand) {
        case 'pilot':
            return 'PILOT';
        case 'kin':
            return 'KIN';
        case 'software':
            return 'SOFTWARE';
        case 'juniper':
            return 'JUNIPER';
        case 'juniper-uk':
            return 'JUNIPER_UK';
        case 'juniper-de':
            return 'JUNIPER_DE';
        case 'juniper-jp':
            return 'JUNIPER_JP';
        case 'compound-uk':
            return 'COMPOUND_UK';
        default:
            throw new Error(`engineBrand ${engineBrand} is not supported`);
    }
}
function brandFromProto(brand) {
    switch (brand) {
        case globals_1.Brand.BRAND_PILOT:
            return 'PILOT';
        case globals_1.Brand.BRAND_KIN:
            return 'KIN';
        case globals_1.Brand.BRAND_SOFTWARE:
            return 'SOFTWARE';
        case globals_1.Brand.BRAND_JUNIPER:
            return 'JUNIPER';
        case globals_1.Brand.BRAND_JUNIPER_UK:
            return 'JUNIPER_UK';
        case globals_1.Brand.BRAND_JUNIPER_DE:
            return 'JUNIPER_DE';
        case globals_1.Brand.BRAND_JUNIPER_JP:
            return 'JUNIPER_JP';
        case globals_1.Brand.BRAND_COMPOUND_UK:
            return 'COMPOUND_UK';
        default:
            throw new Error(`brand ${(0, globals_1.brandToJSON)(brand)} is not supported`);
    }
}
function brandToProto(brand) {
    switch (brand) {
        case 'PILOT':
            return globals_1.Brand.BRAND_PILOT;
        case 'KIN':
            return globals_1.Brand.BRAND_KIN;
        case 'SOFTWARE':
            return globals_1.Brand.BRAND_SOFTWARE;
        case 'JUNIPER':
            return globals_1.Brand.BRAND_JUNIPER;
        case 'JUNIPER_UK':
            return globals_1.Brand.BRAND_JUNIPER_UK;
        case 'JUNIPER_DE':
            return globals_1.Brand.BRAND_JUNIPER_DE;
        case 'JUNIPER_JP':
            return globals_1.Brand.BRAND_JUNIPER_JP;
        case 'COMPOUND_UK':
            return globals_1.Brand.BRAND_COMPOUND_UK;
        default:
            throw new Error(`brand ${brand} is not supported`);
    }
}
function brandToEngineBrand(brand) {
    switch (brand) {
        case 'PILOT':
            return 'pilot';
        case 'KIN':
            return 'kin';
        case 'SOFTWARE':
            return 'software';
        case 'JUNIPER':
            return 'juniper';
        case 'JUNIPER_UK':
            return 'juniper-uk';
        case 'JUNIPER_DE':
            return 'juniper-de';
        case 'JUNIPER_JP':
            return 'juniper-jp';
        case 'COMPOUND_UK':
            return 'compound-uk';
        default:
            throw new Error(`brand ${brand} is not supported`);
    }
}
function stringToBrand(s) {
    switch (s) {
        case 'PILOT':
        case 'KIN':
        case 'SOFTWARE':
        case 'JUNIPER':
        case 'JUNIPER_UK':
        case 'JUNIPER_DE':
        case 'JUNIPER_JP':
        case 'COMPOUND_UK':
            return s;
        default:
            throw new Error(`unrecognized brand "${s}"`);
    }
}
function stringToEngineBrand(s) {
    switch (s) {
        case 'pilot':
        case 'kin':
        case 'software':
        case 'juniper':
        case 'juniper-uk':
        case 'juniper-de':
        case 'juniper-jp':
        case 'compound-uk':
            return s;
        default:
            throw new Error(`unrecognized engineBrand "${s}"`);
    }
}
function engineBrandFromProto(brand) {
    switch (brand) {
        case globals_1.Brand.BRAND_PILOT:
            return 'pilot';
        case globals_1.Brand.BRAND_KIN:
            return 'kin';
        case globals_1.Brand.BRAND_SOFTWARE:
            return 'software';
        case globals_1.Brand.BRAND_JUNIPER:
            return 'juniper';
        case globals_1.Brand.BRAND_JUNIPER_UK:
            return 'juniper-uk';
        case globals_1.Brand.BRAND_JUNIPER_DE:
            return 'juniper-de';
        case globals_1.Brand.BRAND_JUNIPER_JP:
            return 'juniper-jp';
        case globals_1.Brand.BRAND_COMPOUND_UK:
            return 'compound-uk';
        default:
            throw new Error(`brand ${(0, globals_1.brandToJSON)(brand)} is not supported`);
    }
}
function brandToLanguage(brand) {
    switch (brand) {
        case 'PILOT':
            return globals_1.LanguageCode.LANGUAGE_CODE_EN_AU;
        case 'KIN':
            return globals_1.LanguageCode.LANGUAGE_CODE_EN_AU;
        case 'SOFTWARE':
            return globals_1.LanguageCode.LANGUAGE_CODE_EN_AU;
        case 'JUNIPER':
            return globals_1.LanguageCode.LANGUAGE_CODE_EN_AU;
        case 'JUNIPER_UK':
            return globals_1.LanguageCode.LANGUAGE_CODE_EN_GB;
        case 'JUNIPER_DE':
            return globals_1.LanguageCode.LANGUAGE_CODE_DE;
        case 'JUNIPER_JP':
            return globals_1.LanguageCode.LANGUAGE_CODE_JA;
        case 'COMPOUND_UK':
            return globals_1.LanguageCode.LANGUAGE_CODE_EN_GB;
        default:
            throw new Error(`brand ${(0, globals_1.brandToJSON)(brand)} is not supported`);
    }
}
function brandToAnalytics(brand) {
    switch (brand) {
        case 'JUNIPER':
            return {
                brand: 'juniper',
                countryCode: 'AU',
            };
        case 'JUNIPER_DE':
            return {
                brand: 'juniper',
                countryCode: 'DE',
            };
        case 'JUNIPER_JP':
            return {
                brand: 'juniper',
                countryCode: 'JP',
            };
        case 'JUNIPER_UK':
            return {
                brand: 'juniper',
                countryCode: 'GB',
            };
        case 'KIN':
            return {
                brand: 'kin',
                countryCode: 'AU',
            };
        case 'PILOT':
            return {
                brand: 'pilot',
                countryCode: 'AU',
            };
        case 'SOFTWARE':
            return {
                brand: 'software',
                countryCode: 'AU',
            };
        case 'COMPOUND_UK':
            return {
                brand: 'compound',
                countryCode: 'GB',
            };
        default:
            throw new Error(`brand ${brand} is not supported`);
    }
}
function protoBrandToAnalytics(brand) {
    return brandToAnalytics(brandFromProto(brand));
}
function brandAndEnvToAdminUrl(brand, environment) {
    const envSubdomain = environment === 'production' ? '' : 'dev.';
    switch (brand) {
        case 'PILOT':
            return `https://${envSubdomain}admin.pilot.com.au/`;
        case 'KIN':
            return `https://${envSubdomain}admin.kinfertility.com.au/`;
        case 'SOFTWARE':
            return `https://${envSubdomain}admin.skin.software/`;
        case 'JUNIPER':
            return `https://${envSubdomain}admin.myjuniper.com/`;
        case 'JUNIPER_UK':
            return `https://admin.${envSubdomain}myjuniper.co.uk/`;
        case 'JUNIPER_DE':
            return `https://admin.${envSubdomain}.de.myjuniper.com/`;
        case 'JUNIPER_JP':
            return `https://admin.${envSubdomain}myjuniper.jp/`;
        case 'COMPOUND_UK':
            return `https://admin.${envSubdomain}uk.compound.co/`;
        default:
            throw new Error(`unknown brand "${brand}" provided`);
    }
}
/** URL for the customer-facing web portal */
function brandAndEnvToAppUrl(brand, environment) {
    const envSubdomain = environment === 'production' ? '' : 'dev.';
    switch (brand) {
        case 'PILOT':
            return `https://app.${envSubdomain}pilot.com.au`;
        case 'KIN':
            return `https://app.${envSubdomain}kinfertility.com.au`;
        case 'SOFTWARE':
            return `https://app.${envSubdomain}skin.software`;
        case 'JUNIPER':
            return `https://app.${envSubdomain}myjuniper.com`;
        case 'JUNIPER_UK':
            return `https://app.${envSubdomain}myjuniper.co.uk`;
        case 'JUNIPER_DE':
            return `https://app.${envSubdomain}de.myjuniper.com`;
        case 'JUNIPER_JP':
            return `https://app.${envSubdomain}myjuniper.jp`;
        case 'COMPOUND_UK':
            return `https://app.${envSubdomain}uk.compound.co`;
        default:
            throw new Error(`unknown brand "${brand}" provided`);
    }
}
function dayOfWeekToProto(dayOfWeek) {
    switch (dayOfWeek) {
        case 'MONDAY':
            return globals_1.DayOfWeek.DAY_OF_WEEK_MONDAY;
        case 'TUESDAY':
            return globals_1.DayOfWeek.DAY_OF_WEEK_TUESDAY;
        case 'WEDNESDAY':
            return globals_1.DayOfWeek.DAY_OF_WEEK_WEDNESDAY;
        case 'THURSDAY':
            return globals_1.DayOfWeek.DAY_OF_WEEK_THURSDAY;
        case 'FRIDAY':
            return globals_1.DayOfWeek.DAY_OF_WEEK_FRIDAY;
        case 'SATURDAY':
            return globals_1.DayOfWeek.DAY_OF_WEEK_SATURDAY;
        case 'SUNDAY':
            return globals_1.DayOfWeek.DAY_OF_WEEK_SUNDAY;
        default:
            throw new Error(`unrecognised value of day of week "${dayOfWeek}"`);
    }
}
function dayOfWeekFromProto(dayOfWeek) {
    switch (dayOfWeek) {
        case globals_1.DayOfWeek.DAY_OF_WEEK_UNSPECIFIED:
            return null;
        case globals_1.DayOfWeek.DAY_OF_WEEK_MONDAY:
            return 'MONDAY';
        case globals_1.DayOfWeek.DAY_OF_WEEK_TUESDAY:
            return 'TUESDAY';
        case globals_1.DayOfWeek.DAY_OF_WEEK_WEDNESDAY:
            return 'WEDNESDAY';
        case globals_1.DayOfWeek.DAY_OF_WEEK_THURSDAY:
            return 'THURSDAY';
        case globals_1.DayOfWeek.DAY_OF_WEEK_FRIDAY:
            return 'FRIDAY';
        case globals_1.DayOfWeek.DAY_OF_WEEK_SATURDAY:
            return 'SATURDAY';
        case globals_1.DayOfWeek.DAY_OF_WEEK_SUNDAY:
            return 'SUNDAY';
        default:
            throw new Error(`value of day of week "${dayOfWeek}" is not supported`);
    }
}
function problemTypeToProto(problemType) {
    switch (problemType) {
        case 'HAIR':
            return globals_1.ProblemType.PROBLEM_TYPE_HAIR;
        case 'ERECTILE':
            return globals_1.ProblemType.PROBLEM_TYPE_ERECTILE;
        case 'PREMATURE':
            return globals_1.ProblemType.PROBLEM_TYPE_PREMATURE;
        case 'MENTAL_HEALTH_GOOD':
            return globals_1.ProblemType.PROBLEM_TYPE_MENTAL_HEALTH_GOOD;
        case 'MENTAL_HEALTH_MEH':
            return globals_1.ProblemType.PROBLEM_TYPE_MENTAL_HEALTH_MEH;
        case 'MENTAL_HEALTH_SAD':
            return globals_1.ProblemType.PROBLEM_TYPE_MENTAL_HEALTH_SAD;
        case 'SLEEP':
            return globals_1.ProblemType.PROBLEM_TYPE_SLEEP;
        case 'HERPES':
            return globals_1.ProblemType.PROBLEM_TYPE_HERPES;
        case 'COLD_SORES':
            return globals_1.ProblemType.PROBLEM_TYPE_COLD_SORES;
        case 'DEPRECATED_OTC':
            return globals_1.ProblemType.PROBLEM_TYPE_DEPRECATED_OTC;
        case 'CONTRACEPTION':
            return globals_1.ProblemType.PROBLEM_TYPE_CONTRACEPTION;
        case 'ACNE':
            return globals_1.ProblemType.PROBLEM_TYPE_ACNE;
        case 'ANTI_AGEING':
            return globals_1.ProblemType.PROBLEM_TYPE_ANTI_AGEING;
        case 'SKIN_GENERAL':
            return globals_1.ProblemType.PROBLEM_TYPE_SKIN_GENERAL;
        case 'UTI':
            return globals_1.ProblemType.PROBLEM_TYPE_UTI;
        case 'PRECONCEPTION_FERTILITY':
            return globals_1.ProblemType.PROBLEM_TYPE_PRECONCEPTION_FERTILITY;
        case 'PRECONCEPTION_NUTRITION':
            return globals_1.ProblemType.PROBLEM_TYPE_PRECONCEPTION_NUTRITION;
        case 'PREGNANCY':
            return globals_1.ProblemType.PROBLEM_TYPE_PREGNANCY;
        case 'POSTPARTUM':
            return globals_1.ProblemType.PROBLEM_TYPE_POSTPARTUM;
        case 'FERTILITY':
            return globals_1.ProblemType.PROBLEM_TYPE_FERTILITY;
        case 'PRECONCEPTION_MENTAL_HEALTH':
            return globals_1.ProblemType.PROBLEM_TYPE_PRECONCEPTION_MENTAL_HEALTH;
        case 'PRECONCEPTION_PHYSIO':
            return globals_1.ProblemType.PROBLEM_TYPE_PRECONCEPTION_PHYSIO;
        case 'PREGNANCY_NUTRITION':
            return globals_1.ProblemType.PROBLEM_TYPE_PREGNANCY_NUTRITION;
        case 'PREGNANCY_MENTAL_HEALTH':
            return globals_1.ProblemType.PROBLEM_TYPE_PREGNANCY_MENTAL_HEALTH;
        case 'PREGNANCY_PHYSIO':
            return globals_1.ProblemType.PROBLEM_TYPE_PREGNANCY_PHYSIO;
        case 'POSTPARTUM_NUTRITION':
            return globals_1.ProblemType.PROBLEM_TYPE_POSTPARTUM_NUTRITION;
        case 'POSTPARTUM_MENTAL_HEALTH':
            return globals_1.ProblemType.PROBLEM_TYPE_POSTPARTUM_MENTAL_HEALTH;
        case 'POSTPARTUM_PHYSIO':
            return globals_1.ProblemType.PROBLEM_TYPE_POSTPARTUM_PHYSIO;
        case 'BREASTFEEDING':
            return globals_1.ProblemType.PROBLEM_TYPE_BREASTFEEDING;
        case 'INFANT_SLEEP':
            return globals_1.ProblemType.PROBLEM_TYPE_INFANT_SLEEP;
        case 'STI':
            return globals_1.ProblemType.PROBLEM_TYPE_STI;
        case 'FERTILITY_NAVIGATOR':
            return globals_1.ProblemType.PROBLEM_TYPE_FERTILITY_NAVIGATOR;
        case 'FERTILITY_HORMONE':
            return globals_1.ProblemType.PROBLEM_TYPE_FERTILITY_HORMONE;
        case 'WEIGHT_LOSS':
            return globals_1.ProblemType.PROBLEM_TYPE_WEIGHT_LOSS;
        case 'MENOPAUSE':
            return globals_1.ProblemType.PROBLEM_TYPE_MENOPAUSE;
        case 'FERTILITY_NAVIGATOR_PREGNANCY':
            return globals_1.ProblemType.PROBLEM_TYPE_FERTILITY_NAVIGATOR_PREGNANCY;
        case 'GENETIC_TEST':
            return globals_1.ProblemType.PROBLEM_TYPE_GENETIC_TEST;
        case 'WOMENS_HEALTH':
            return globals_1.ProblemType.PROBLEM_TYPE_WOMENS_HEALTH;
        default:
            throw new Error(`unrecognised value of problem type "${problemType}"`);
    }
}
function problemTypeFromProto(protoProblemType) {
    switch (protoProblemType) {
        case globals_1.ProblemType.PROBLEM_TYPE_HAIR:
            return 'HAIR';
        case globals_1.ProblemType.PROBLEM_TYPE_ERECTILE:
            return 'ERECTILE';
        case globals_1.ProblemType.PROBLEM_TYPE_PREMATURE:
            return 'PREMATURE';
        case globals_1.ProblemType.PROBLEM_TYPE_MENTAL_HEALTH_GOOD:
            return 'MENTAL_HEALTH_GOOD';
        case globals_1.ProblemType.PROBLEM_TYPE_MENTAL_HEALTH_MEH:
            return 'MENTAL_HEALTH_MEH';
        case globals_1.ProblemType.PROBLEM_TYPE_MENTAL_HEALTH_SAD:
            return 'MENTAL_HEALTH_SAD';
        case globals_1.ProblemType.PROBLEM_TYPE_SLEEP:
            return 'SLEEP';
        case globals_1.ProblemType.PROBLEM_TYPE_HERPES:
            return 'HERPES';
        case globals_1.ProblemType.PROBLEM_TYPE_COLD_SORES:
            return 'COLD_SORES';
        case globals_1.ProblemType.PROBLEM_TYPE_DEPRECATED_OTC:
            return 'DEPRECATED_OTC';
        case globals_1.ProblemType.PROBLEM_TYPE_CONTRACEPTION:
            return 'CONTRACEPTION';
        case globals_1.ProblemType.PROBLEM_TYPE_ACNE:
            return 'ACNE';
        case globals_1.ProblemType.PROBLEM_TYPE_ANTI_AGEING:
            return 'ANTI_AGEING';
        case globals_1.ProblemType.PROBLEM_TYPE_SKIN_GENERAL:
            return 'SKIN_GENERAL';
        case globals_1.ProblemType.PROBLEM_TYPE_UTI:
            return 'UTI';
        case globals_1.ProblemType.PROBLEM_TYPE_PRECONCEPTION_FERTILITY:
            return 'PRECONCEPTION_FERTILITY';
        case globals_1.ProblemType.PROBLEM_TYPE_PRECONCEPTION_NUTRITION:
            return 'PRECONCEPTION_NUTRITION';
        case globals_1.ProblemType.PROBLEM_TYPE_PREGNANCY:
            return 'PREGNANCY';
        case globals_1.ProblemType.PROBLEM_TYPE_POSTPARTUM:
            return 'POSTPARTUM';
        case globals_1.ProblemType.PROBLEM_TYPE_FERTILITY:
            return 'FERTILITY';
        case globals_1.ProblemType.PROBLEM_TYPE_PRECONCEPTION_MENTAL_HEALTH:
            return 'PRECONCEPTION_MENTAL_HEALTH';
        case globals_1.ProblemType.PROBLEM_TYPE_PRECONCEPTION_PHYSIO:
            return 'PRECONCEPTION_PHYSIO';
        case globals_1.ProblemType.PROBLEM_TYPE_PREGNANCY_NUTRITION:
            return 'PREGNANCY_NUTRITION';
        case globals_1.ProblemType.PROBLEM_TYPE_PREGNANCY_MENTAL_HEALTH:
            return 'PREGNANCY_MENTAL_HEALTH';
        case globals_1.ProblemType.PROBLEM_TYPE_PREGNANCY_PHYSIO:
            return 'PREGNANCY_PHYSIO';
        case globals_1.ProblemType.PROBLEM_TYPE_POSTPARTUM_NUTRITION:
            return 'POSTPARTUM_NUTRITION';
        case globals_1.ProblemType.PROBLEM_TYPE_POSTPARTUM_MENTAL_HEALTH:
            return 'POSTPARTUM_MENTAL_HEALTH';
        case globals_1.ProblemType.PROBLEM_TYPE_POSTPARTUM_PHYSIO:
            return 'POSTPARTUM_PHYSIO';
        case globals_1.ProblemType.PROBLEM_TYPE_BREASTFEEDING:
            return 'BREASTFEEDING';
        case globals_1.ProblemType.PROBLEM_TYPE_INFANT_SLEEP:
            return 'INFANT_SLEEP';
        case globals_1.ProblemType.PROBLEM_TYPE_STI:
            return 'STI';
        case globals_1.ProblemType.PROBLEM_TYPE_FERTILITY_NAVIGATOR:
            return 'FERTILITY_NAVIGATOR';
        case globals_1.ProblemType.PROBLEM_TYPE_FERTILITY_HORMONE:
            return 'FERTILITY_HORMONE';
        case globals_1.ProblemType.PROBLEM_TYPE_WEIGHT_LOSS:
            return 'WEIGHT_LOSS';
        case globals_1.ProblemType.PROBLEM_TYPE_MENOPAUSE:
            return 'MENOPAUSE';
        case globals_1.ProblemType.PROBLEM_TYPE_FERTILITY_NAVIGATOR_PREGNANCY:
            return 'FERTILITY_NAVIGATOR_PREGNANCY';
        case globals_1.ProblemType.PROBLEM_TYPE_GENETIC_TEST:
            return 'GENETIC_TEST';
        case globals_1.ProblemType.PROBLEM_TYPE_WOMENS_HEALTH:
            return 'WOMENS_HEALTH';
        default:
            throw new Error(`unrecognised value of proto problem type "${protoProblemType}"`);
    }
}
function stringToProblemType(s) {
    switch (s) {
        case 'HAIR':
            return s;
        case 'ERECTILE':
            return s;
        case 'PREMATURE':
            return s;
        case 'MENTAL_HEALTH_GOOD':
            return s;
        case 'MENTAL_HEALTH_MEH':
            return s;
        case 'MENTAL_HEALTH_SAD':
            return s;
        case 'SLEEP':
            return s;
        case 'HERPES':
            return s;
        case 'COLD_SORES':
            return s;
        case 'DEPRECATED_OTC':
            return s;
        case 'CONTRACEPTION':
            return s;
        case 'ACNE':
            return s;
        case 'ANTI_AGEING':
            return s;
        case 'SKIN_GENERAL':
            return s;
        case 'UTI':
            return s;
        case 'PRECONCEPTION_FERTILITY':
            return s;
        case 'PRECONCEPTION_NUTRITION':
            return s;
        case 'PREGNANCY':
            return s;
        case 'POSTPARTUM':
            return s;
        case 'FERTILITY':
            return s;
        case 'PRECONCEPTION_MENTAL_HEALTH':
            return s;
        case 'PRECONCEPTION_PHYSIO':
            return s;
        case 'PREGNANCY_NUTRITION':
            return s;
        case 'PREGNANCY_MENTAL_HEALTH':
            return s;
        case 'PREGNANCY_PHYSIO':
            return s;
        case 'POSTPARTUM_NUTRITION':
            return s;
        case 'POSTPARTUM_MENTAL_HEALTH':
            return s;
        case 'POSTPARTUM_PHYSIO':
            return s;
        case 'BREASTFEEDING':
            return s;
        case 'INFANT_SLEEP':
            return s;
        case 'STI':
            return s;
        case 'FERTILITY_NAVIGATOR':
            return s;
        case 'FERTILITY_HORMONE':
            return s;
        case 'WEIGHT_LOSS':
            return s;
        case 'MENOPAUSE':
            return s;
        case 'FERTILITY_NAVIGATOR_PREGNANCY':
            return s;
        case 'GENETIC_TEST':
            return s;
        case 'WOMENS_HEALTH':
            return s;
        default:
            throw new Error(`unrecognised problem type "${s}"`);
    }
}
const maxPageSize = 75;
/**
 * Calculates the limit and offset for a PageRequest.
 *
 * PageRequest.pageSize dictates the limit upto a max of 75, it is ignored when a pageToken is provided.
 * PageRequest.skip offsets the default(0) or further offsets the pageToken's offset.
 */
function getPaginationControls(pageRequest) {
    let limit = 10;
    let offset = 0;
    if (!pageRequest) {
        return {
            limit,
            offset,
        };
    }
    if (pageRequest.skip) {
        offset += pageRequest.skip;
    }
    if (pageRequest.pageToken) {
        let tokenJson;
        try {
            tokenJson = JSON.parse(Buffer.from(pageRequest.pageToken, 'base64').toString('utf-8'));
        }
        catch (e) {
            throw new Error('Invalid page token');
        }
        const token = zod_1.default
            .object({
            limit: zod_1.default.number(),
            offset: zod_1.default.number(),
        })
            .safeParse(tokenJson);
        if (!token.success) {
            throw new Error('Page token is in an unexpected shape');
        }
        return {
            limit: token.data.limit,
            offset: offset + token.data.offset,
        };
    }
    if (pageRequest.pageSize) {
        limit = Math.min(pageRequest.pageSize, maxPageSize);
    }
    return {
        limit,
        offset,
    };
}
/**
 * @deprecated Use getPaginationControls instead
 */
function limitOffsetFromPageRequest(pageRequest) {
    let limit = 10;
    const defaultOffset = 0;
    if (!pageRequest) {
        return [limit, defaultOffset];
    }
    if (pageRequest.pageSize) {
        limit = Math.min(pageRequest.pageSize, maxPageSize);
    }
    if (!pageRequest.pageToken) {
        return [limit, defaultOffset];
    }
    const pageTokenSchema = zod_1.default.object({
        limit: zod_1.default.number(),
        offset: zod_1.default.number(),
    });
    let parsedToken;
    try {
        parsedToken = pageTokenSchema.parse(JSON.parse(Buffer.from(pageRequest.pageToken, 'base64').toString('ascii')));
    }
    catch (e) {
        throw new Error('parsing page token');
    }
    if (!pageRequest.pageSize && parsedToken.limit <= maxPageSize) {
        limit = parsedToken.limit;
    }
    return [limit, parsedToken.offset];
}
function nextPageTokenFromLimitOffset(limit, offset) {
    return Buffer.from(JSON.stringify({ limit: Math.min(limit, maxPageSize), offset })).toString('base64');
}
